import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SchoolHeroSection from './components/SchoolHeroSection';
import WhyLicenseSection from './components/WhyLicenseSection';
import FeaturesSection from './components/FeaturesSection';
import CoursePricingSection from './components/CoursePricingSection';
import ProcessSection from './components/ProcessSection';
import LocationsSection from './components/LocationsSection';
import AssociationSection from './components/AssociationSection';
import FAQSection from './components/FAQSection';
import RelatedLinksSection from './components/RelatedLinksSection';
import CTASection from './components/CTASection';

export default function SchoolPage() {
  useEffect(() => {
    // Set page title
    document.title = '農業ドローンスクール｜最短2日で資格取得｜佐賀・福岡・鹿児島｜IDS教習所｜農業ドローン協議会認定';

    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '農業ドローン協議会認定スクール。DJI農業ドローンオペレーター技能認定資格を最短2日で取得。オフライン未経験者コース（5日・237,600円）、経験者コース（4日・193,600円）、オンライン未経験者コース（3日・193,600円）、経験者コース（2日・138,600円）。座学17時間+実技19時間の実践的講習。佐賀県多久市・佐賀市・鹿児島県日置市の3拠点で随時開催。無料相談受付中。');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', '農業ドローンスクール,ドローン資格,農業ドローン協議会,オペレーター技能認定,DJI AGRAS,ドローン講習,ドローン教習所,IDS教習所,佐賀県,多久市,佐賀市,鹿児島県,日置市,福岡県,オンライン講習,最短2日,資格取得,未経験者,経験者,138600円,193600円,237600円');
    }

    // Canonical URL
    const canonicalLink = document.querySelector('link[rel="canonical"]') || document.createElement('link');
    canonicalLink.setAttribute('rel', 'canonical');
    canonicalLink.setAttribute('href', 'https://ids-group.jp/school');
    if (!document.querySelector('link[rel="canonical"]')) {
      document.head.appendChild(canonicalLink);
    }

    // OGタグの設定
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', '農業ドローンスクール｜最短2日で資格取得｜佐賀・福岡・鹿児島｜IDS教習所｜農業ドローン協議会認定');

    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) {
      ogDescription = document.createElement('meta');
      ogDescription.setAttribute('property', 'og:description');
      document.head.appendChild(ogDescription);
    }
    ogDescription.setAttribute('content', '農業ドローン協議会認定スクール。DJI農業ドローンオペレーター技能認定資格を最短2日で取得。オフライン未経験者コース（5日・237,600円）、経験者コース（4日・193,600円）、オンライン未経験者コース（3日・193,600円）、経験者コース（2日・138,600円）。座学17時間+実技19時間の実践的講習。佐賀県多久市・佐賀市・鹿児島県日置市の3拠点で随時開催。無料相談受付中。');

    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (!ogUrl) {
      ogUrl = document.createElement('meta');
      ogUrl.setAttribute('property', 'og:url');
      document.head.appendChild(ogUrl);
    }
    ogUrl.setAttribute('content', 'https://ids-group.jp/school');

    let ogType = document.querySelector('meta[property="og:type"]');
    if (!ogType) {
      ogType = document.createElement('meta');
      ogType.setAttribute('property', 'og:type');
      document.head.appendChild(ogType);
    }
    ogType.setAttribute('content', 'website');

    // JSON-LD構造化データの追加
    const educationalOrgSchema = {
      "@context": "https://schema.org",
      "@type": "EducationalOrganization",
      "name": "IDS教習所グループ 農業ドローンスクール",
      "description": "農業ドローン協議会認定教習所。最短2日でDJI農業ドローン操縦士資格を取得。オンライン/オフライン選択可。佐賀・福岡・鹿児島3拠点で随時開催。",
      "url": "https://ids-group.jp/school",
      "telephone": "+81952719855",
      "email": "info@ids-group.jp",
      "address": [
        {
          "@type": "PostalAddress",
          "streetAddress": "北多久町大字小侍4771",
          "addressLocality": "多久市",
          "addressRegion": "佐賀県",
          "postalCode": "846-0002",
          "addressCountry": "JP"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "川副町小々森146-1",
          "addressLocality": "佐賀市",
          "addressRegion": "佐賀県",
          "postalCode": "840-2213",
          "addressCountry": "JP"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "伊集院町古城795",
          "addressLocality": "日置市",
          "addressRegion": "鹿児島県",
          "postalCode": "899-2504",
          "addressCountry": "JP"
        }
      ],
      "areaServed": ["佐賀県", "福岡県筑後地域", "鹿児島県"],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "農業ドローン操縦士養成コース",
        "itemListElement": [
          {
            "@type": "Course",
            "name": "オフライン教習 未経験者コース",
            "description": "全過程対面実施。座学17時間・実技19時間で確実にスキル習得。",
            "provider": {
              "@type": "Organization",
              "name": "IDS教習所グループ"
            },
            "offers": {
              "@type": "Offer",
              "price": 237600,
              "priceCurrency": "JPY",
              "category": "全過程対面"
            },
            "timeRequired": "P5D",
            "educationalCredentialAwarded": "DJI農業ドローンオペレーター技能認定"
          },
          {
            "@type": "Course",
            "name": "オフライン教習 経験者コース",
            "description": "他団体資格保有者向け。座学17時間・実技10時間。",
            "provider": {
              "@type": "Organization",
              "name": "IDS教習所グループ"
            },
            "offers": {
              "@type": "Offer",
              "price": 193600,
              "priceCurrency": "JPY",
              "category": "全過程対面"
            },
            "timeRequired": "P4D",
            "educationalCredentialAwarded": "DJI農業ドローンオペレーター技能認定"
          },
          {
            "@type": "Course",
            "name": "オンライン教習 未経験者コース",
            "description": "最短コース。座学オンライン5時間・実技教習所19時間。",
            "provider": {
              "@type": "Organization",
              "name": "IDS教習所グループ"
            },
            "offers": {
              "@type": "Offer",
              "price": 193600,
              "priceCurrency": "JPY",
              "category": "ハイブリッド"
            },
            "timeRequired": "P3D",
            "educationalCredentialAwarded": "DJI農業ドローンオペレーター技能認定"
          },
          {
            "@type": "Course",
            "name": "オンライン教習 経験者コース",
            "description": "最短・最安コース。座学オンライン5時間・実技教習所11時間。",
            "provider": {
              "@type": "Organization",
              "name": "IDS教習所グループ"
            },
            "offers": {
              "@type": "Offer",
              "price": 138600,
              "priceCurrency": "JPY",
              "category": "ハイブリッド"
            },
            "timeRequired": "P2D",
            "educationalCredentialAwarded": "DJI農業ドローンオペレーター技能認定"
          }
        ]
      },
      "accreditedBy": {
        "@type": "Organization",
        "name": "農業ドローン協議会"
      }
    };

    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "ホーム",
          "item": "https://ids-group.jp/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "農業ドローンスクール",
          "item": "https://ids-group.jp/school"
        }
      ]
    };

    // 既存のスクリプトタグを削除
    const existingEducationalScript = document.querySelector('script[data-schema="school-educational"]');
    if (existingEducationalScript) {
      existingEducationalScript.remove();
    }

    const existingBreadcrumbScript = document.querySelector('script[data-schema="school-breadcrumb"]');
    if (existingBreadcrumbScript) {
      existingBreadcrumbScript.remove();
    }

    // 新しいスクリプトタグを追加
    const educationalScriptTag = document.createElement('script');
    educationalScriptTag.type = 'application/ld+json';
    educationalScriptTag.setAttribute('data-schema', 'school-educational');
    educationalScriptTag.textContent = JSON.stringify(educationalOrgSchema);
    document.head.appendChild(educationalScriptTag);

    const breadcrumbScriptTag = document.createElement('script');
    breadcrumbScriptTag.type = 'application/ld+json';
    breadcrumbScriptTag.setAttribute('data-schema', 'school-breadcrumb');
    breadcrumbScriptTag.textContent = JSON.stringify(breadcrumbSchema);
    document.head.appendChild(breadcrumbScriptTag);

    // クリーンアップ
    return () => {
      const educationalScript = document.querySelector('script[data-schema="school-educational"]');
      if (educationalScript) {
        educationalScript.remove();
      }
      const breadcrumbScript = document.querySelector('script[data-schema="school-breadcrumb"]');
      if (breadcrumbScript) {
        breadcrumbScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <SchoolHeroSection />
        <WhyLicenseSection />
        <FeaturesSection />
        <CoursePricingSection />
        <ProcessSection />
        <LocationsSection />
        <AssociationSection />
        <FAQSection />
        <RelatedLinksSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
